export default {
  title: {
    id: 'outlet_sold_out_page_title',
    defaultMessage: 'Sold out for now',
  },
  description: {
    id: 'outlet_sold_out_page_description',
    defaultMessage: 'These flew off the shelves, but more will be back soon.',
  },
  seeSimilarItems: {
    id: 'outlet_sold_out_page_see_similar_items',
    defaultMessage: 'See similar items',
  },
}
